
$(document).ready(function() {
    const $sliders = $('.top-category__slider');
    $sliders.slick({
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    const $buttons = $('.top-category__button');
    $buttons.on('click', function () {
        const $this = $(this);

        $buttons.removeClass("active");
        $this.addClass("active");

        const value = $this.val();
        $sliders.removeClass("active");

        const $slider = $('.' + value + '-slider');
        $slider.addClass("active");

        $slider.slick('slickGoTo', 0);
        $slider.slick('setPosition');
    });
});
